export enum TrialReimbursementType {
  Other = 'other',
  Travel = 'travel',
}
